import { PortfolioStringFilterType } from '@mews-commander/data-access';
import { SelectField, SelectFieldProps } from '@mews-commander/form';
import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { createOption } from '@mews-commander/ui';
import { usePortfolioCentralRateGroupOverview } from '../../../../queries';
import { CENTRAL_RATE_GROUP_ID_FIELD_NAME } from './schema';

interface CentralRateGroupSelectFieldProps
    extends Omit<SelectFieldProps, 'label' | 'loader' | 'showEmptyValue' | 'name' | 'options'> {
    serviceKey?: string | null;
}

export const CentralRateGroupSelectField = ({ serviceKey, ...rest }: CentralRateGroupSelectFieldProps) => {
    const serviceKeyFilters = serviceKey ? [{ filterType: PortfolioStringFilterType.Equals, value: serviceKey }] : [];
    const { data, isFetching } = usePortfolioCentralRateGroupOverview({
        pagination: { pageSize: 100, pageIndex: 0, show: true },
        sort: {},
        globalFilters: {},
        filters: {
            serviceKey: serviceKeyFilters,
        },
        expanded: {},
    });

    const centralRateGroups =
        data?.data?.map((centralRateGroup) =>
            createOption({
                label: centralRateGroup.name,
                value: centralRateGroup.id,
            })
        ) || [];

    return (
        <SelectField
            {...rest}
            label={<LocalizedText textKey={TextKey.LinkCentralFieldLabelCentralRateGroup} />}
            loader={isFetching}
            showEmptyValue={false}
            name={CENTRAL_RATE_GROUP_ID_FIELD_NAME}
            options={centralRateGroups}
        />
    );
};
